import { IVariant, CustomVariantValues, CustomProductItem } from '../type';
import { generateErrorKey } from 'src/tools/helper';
import _ from 'lodash';
export const variantProductCheck = (
  variants: IVariant<CustomVariantValues, CustomProductItem>[],
) => {
  const _variants = _.cloneDeep(variants);

  let flag;
  _variants.forEach((variant) => {
    const { product, values } = variant;
    const { name } = product;
    if (!name) {
      variant.product[generateErrorKey('name')] = true;
      flag = true;
    }
    Object.keys(values).forEach((key) => {
      if (!(values[key] || {}).value) {
        (values[key] || {})[generateErrorKey('value')] = true;
        flag = true;
      }
    });
  });
  const isEmpty = !!!_variants.length;
  return { data: _variants, flag, isEmpty };
};
